import { Injectable } from '@angular/core';
import { LoginRequest } from '../interfaces/loginRequest';
import { Observable, from, ReplaySubject } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {
  APP_CONFIG,
  AUTH_USER_CODE,
  COMPANY_COUNTRIES,
  CONVERSATION_CODE,
  COUNTRY_GATEWAY_PAGE_CODE,
  DEVICE_INFO,
  HOME_PAGE_VIEW_MODEL,
  LOGIN_FROM_INSIDE,
  URL_LOGIN,
  URL_LOGOUT,
  URL_LOG_ENTER,
} from '../interfaces/constants';
import { LoginResponse } from '../interfaces/loginResponse';
import { AppService } from './app.service';
import { AuthUser } from '../interfaces/authUser';
import { Storage } from '@ionic/storage-angular';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class AuthenticationService {
  password: string = null;
  authNotifier: ReplaySubject<boolean> = new ReplaySubject();
  menuNotifier: ReplaySubject<boolean> = new ReplaySubject();

  constructor(
    private http: HttpClient,
    private appService: AppService,
    private storage: Storage,
    private router: Router
  ) {
    this.isLogged();
    this.isMenu();
  }

  isLogged() {
    const authUser = this.getAuthUser();
    if (authUser === undefined || authUser === null) {
      this.authNotifier.next(false);
    } else {
      this.authNotifier.next(true);
    }
  }

  isMenu() {
    if (
      localStorage.getItem('menu') !== null &&
      localStorage.getItem('menu') !== undefined
    ) {
      this.menuNotifier.next(true);
    } else {
      this.menuNotifier.next(false);
    }
  }

  login(user: LoginRequest): Observable<LoginResponse> {
    this.password = user.password;
    return this.http.post<LoginResponse>(URL_LOGIN, user);
  }

  setToken(username: string, token: string) {
    if (localStorage.getItem('token')) {
      localStorage.removeItem('token');
    }
    localStorage.setItem('token', btoa(username + ':' + token));
  }

  logout() {
    if (localStorage.getItem('token') !== null) {
      localStorage.removeItem('token');
    }
    if (localStorage.getItem('menu') !== null) {
      localStorage.removeItem('menu');
    }
    if (localStorage.getItem('article') !== null) {
      localStorage.removeItem('article');
    }
    if (localStorage.getItem('test') !== null) {
      localStorage.removeItem('test');
    }
    if (localStorage.getItem(APP_CONFIG) !== null) {
      localStorage.removeItem(APP_CONFIG);
    }
    if (localStorage.getItem(DEVICE_INFO) !== null) {
      localStorage.removeItem(DEVICE_INFO);
    }
    if (localStorage.getItem(AUTH_USER_CODE) !== null) {
      localStorage.removeItem(AUTH_USER_CODE);
    }
    if (localStorage.getItem(COUNTRY_GATEWAY_PAGE_CODE) !== null) {
      localStorage.removeItem(COUNTRY_GATEWAY_PAGE_CODE);
    }
    if (localStorage.getItem(HOME_PAGE_VIEW_MODEL) !== null) {
      localStorage.removeItem(HOME_PAGE_VIEW_MODEL);
    }
    if (localStorage.getItem(LOGIN_FROM_INSIDE) !== null) {
      localStorage.removeItem(LOGIN_FROM_INSIDE);
    }
    if (localStorage.getItem(COMPANY_COUNTRIES) !== null) {
      localStorage.removeItem(COMPANY_COUNTRIES);
    }
    this.appService.authUser = new AuthUser();
    this.authNotifier.next(false);
    this.menuNotifier.next(false);
    return this.http.post(URL_LOGOUT, null);
  }

  updateCountryToken(): Observable<any> {
    const user = this.getAuthUser();
    return this.http.patch(URL_LOGIN, [
      {
        op: 'replace',
        path: '/CountryCode',
        value: user.countryCode,
      },
    ]);
  }

  getAuthUser() {
    if (localStorage.getItem(AUTH_USER_CODE) !== null) {
      return JSON.parse(localStorage.getItem(AUTH_USER_CODE));
    } else {
      return null;
    }
  }

  createAuthUser(loginResponseModel: LoginResponse) {
    this.appService.authUser = loginResponseModel;
    this.updateAuthUser(this.appService.authUser);
  }

  updateAuthUser(authUser?: AuthUser) {
    Object.assign(this.appService.authUser, authUser);
    localStorage.setItem(
      AUTH_USER_CODE,
      JSON.stringify(this.appService.authUser)
    );
  }

  logEnter(authUser?: AuthUser): Observable<any> {
    return this.http.post(URL_LOG_ENTER, {
      ...this.appService.authUser,
      password: this.password,
    });
  }
}
